import Button from '@mui/material/Button'
import Box from '@mui/material/Box'
import Grid from '@mui/material/Grid'
import Typography from '@mui/material/Typography'
import styled from '@emotion/styled'

export const OneLineGrid = styled(Grid)`
  height: ${({ $height }) => $height || '72px'};
  width: ${({ $width }) => $width};
  overflow-y: hidden;
`

// Button 會把小寫轉成大寫，目前不影響
const StyledTag = styled(Button)`
  ${({ theme, size, shape }) => `
    font-size: 14px;
    color: ${theme.palette.text.minus2};
    background: ${theme.palette.grey.third};
    padding: ${
      {
        sm: '10px 12px',
        md: '10px 16px',
        lg: '12px 20px',
        xl: '12px 20px',
      }[size]
    };
    border-radius: ${
      {
        round: '20px',
        rectangle: '6px',
      }[shape]
    };
    cursor: default;

    &:hover {
      background-color: ${theme.palette.primary.bgPlus1};
      box-shadow: none; // shadow override worked here only in ios browser
    }
    &:active {
      background-color: ${theme.palette.primary.main};
      color: #ffffff;
    }
  `}
`

const Tag = ({ children, shape = 'round', size = 'md', ...rest }) => {
  return (
    <StyledTag variant="contained" color="grey" shape={shape} size={size}>
      <Typography
        sx={{
          typography: {
            sm: 'bodyXs',
            md: 'bodySmall',
            lg: 'bodyMedium',
            xl: 'bodyLarge',
          }[size],
        }}
      >
        {children}
      </Typography>
    </StyledTag>
  )
}

export default Tag
